import { render, staticRenderFns } from "./SlaTicketBreakdown.vue?vue&type=template&id=182dbb5e&"
import script from "./SlaTicketBreakdown.vue?vue&type=script&lang=js&"
export * from "./SlaTicketBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports